export default "__VITE_ASSET__ad139ccd__"